module.exports = __webpack_public_path__ + "de12e0b2404a1a6adb91b8d30feb34d6.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/styles/6_column_xlarge_x1/public/picture/Yaletown.jpg
// module id = 494
// module chunks = 0